import { render, staticRenderFns } from "./SignUpUser.vue?vue&type=template&id=64c71cc2&scoped=true"
import script from "./SignUpUser.vue?vue&type=script&lang=js"
export * from "./SignUpUser.vue?vue&type=script&lang=js"
import style0 from "./SignUpUser.vue?vue&type=style&index=0&id=64c71cc2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c71cc2",
  null
  
)

export default component.exports